import { CalculationResult } from './calculationModels';

export class UserMatrixRowModel {
    userMatrixRowId: string;
    userMatrixId: string;
    jointID: string;
    calculation: string;

    get calculationResult(): CalculationResult {
        return JSON.parse(this.calculation);
    }
}
